import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-divider"></div>
      <div className="footer-background">
        <img 
          src="https://api.builder.io/api/v1/image/assets/TEMP/bd2ca76f3b8afd5e2a3a88c8d7c8658968ba201c?width=2400" 
          alt=""
          className="footer-dots-bg"
          aria-hidden="true"
        />
      </div>
      
      <div className="footer-content">
        <div className="footer-logo">
          <img 
            src="/logo-sbx.png" 
            alt="SBX Trade Academy Logo"
            className="logo-image"
          />
        </div>
        
        <div className="footer-copyright">
          <p className="copyright-text">
            © 2025 SBX Trade Academy. Todos os direitos reservados
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
